var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395.89 448.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-2 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-3 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-7 {\n        letter-spacing: .08em;\n      }\n\n      .cls-8 {\n        font-family: MadeynSans-Bold, MadeynSans;\n        font-size: 42px;\n        font-weight: 700;\n      }\n\n      .cls-8, .cls-9 {\n        fill: #000a50;\n      }\n\n      .cls-10 {\n        fill: #00166a;\n      }\n\n      .cls-10, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-11 {\n        letter-spacing: -.02em;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "298.49 374.97 275.79 374.97 204.84 210.65 227.54 210.65 298.49 374.97"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "159.32 168.96 136.62 168.96 204.67 13.58 227.36 13.58 159.32 168.96"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "185.69 301.7 162.99 301.7 123.13 211.62 145.82 211.62 185.69 301.7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "36.57 374.75 13.87 374.75 117.83 126.22 140.53 126.22 36.57 374.75"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "231.36 13.58 383.77 374.97 301.49 374.97 230.54 210.65 188.69 301.7 148.82 211.62 82.85 374.75 40.57 374.75 144.53 126.22 163.32 168.96 231.36 13.58"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(10.96 421)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "MISH"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 98.91,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 129.02,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 155.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 166.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 180.51,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 212.73,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 241.83,
    y: 0
  }, "RKE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 322.51,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 348.6,
    y: 0
  }, "S"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.7e1b4067baba2ade60b852855e508b4f.svg";
export { ForwardRef as ReactComponent };